/* Component in IndexCards to display each the Card */
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import Card from "react-bootstrap/Card"
import { axiosReq, axiosInstance } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import styles from "../../styles/Indexes.module.css"
import IndexCardEdit from "./IndexCardEdit"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import toast from "react-hot-toast";

const IndexCard = (props) => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const [showEdit, setShowEdit] = useState(false)
  const { setHasOrder, card, setIndexCards } = props

  const { id, number, story, style } = card

  const handleEdit = () => {
    setShowEdit(true)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/indexcards/${id}/`)
        setHasOrder(true)
        toast.success(`Index Card Deleted Successfully`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/indexcards/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        setHasOrder(true)
        toast.success(`Index Card Deleted Successfully!`);
      }
    } catch (err) {}
  }
  return (
    <div>
      <Card className={`${styles.Card} text-center`}  >
        <Card.Header className={`py-0 ${styles.Top }`}>
          <Row>
            <Col className="mx-0 px-0" xs={1}></Col>
            <Col xs={10} className="mx-0 px-0 text-center">
              <h5 className={` ${styles.Titlelist}`}>{number}</h5>
            </Col>
            <Col xs={1} className="text-center mx-0 px-0">
              {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Admin" ||
                  currentUser?.groups[0]?.name === "Superadmin" ||
                  currentUser?.groups[0]?.name === "Admincreative") && (
                  <PostDropdown
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                  />
                )}
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className={`py-0 ${styles.White }`} >
        <Row>
        <Col className='text-center mt-0' xs={12}>
            <div className={`${styles.DivSize } text-center px-1`}>
              <p className={`${styles.Title } mb-0 pb-0`}>Story</p>
              <p className={`mb-0 pb-0`}>{story} </p>
            </div>
            <hr className='my-0 py-0' />
            <div className={`${styles.DivSize } text-center px-1`}>
              <p className={`${styles.Title }`}>Style</p>
              <p className={`${styles.Italic } mb-0 pb-0`}>{style} </p>
            </div>
        </Col>
        </Row>
        </Card.Body>
      </Card>
      {!showEdit ? (
        ""
      ) : (
        <IndexCardEdit
          setIndexCards={setIndexCards}
          card={card}
          number={number}
          id={id}
          setShowEdit={setShowEdit}
          setHasOrder={setHasOrder}
        />
      )}
    </div>
  )
}

export default IndexCard
